<template>
  <el-form-item prop="adFormat" label="着陆页">
    <div class="landing-page-title">商品详情页</div>
    <div class="selected-cell not-selected" v-if="!creative.asinsItem || creative.asinsItem.length == 0" @click="addCommodity">
      <i class="el-icon-plus"></i>
      <span class="add">添加商品</span>
    </div>
    <div class="selected-cell selected" v-else>
      <div class="img">
        <gj-image :src="row.imageUrl"></gj-image>
      </div>
      <div class="main">
        <gj-tooltip
          :text-line="1"
          :content="row.title">
          {{row.title | defaultShow}}
        </gj-tooltip>
        <el-row>
          <el-col :span="8">
            <span style="font-weight: 500;">ASIN：</span>{{row.asin | defaultShow}}
          </el-col>
          <el-col :span="11">
            <span style="font-weight: 500;">MSKU：</span>{{row.msku | defaultShow}}
          </el-col>
          <el-col :span="5">
            <span style="font-weight: 500;">FBA库存：</span>{{row.fba | defaultShow}}
          </el-col>
        </el-row>
      </div>
      <div class="add" @click="addCommodity">重新选择</div>
      <div></div>
    </div>
  </el-form-item>
</template>
<script>
import PopupCommodity from "@/views/modules/ad/sb/common/modal/add/common/popup-commodity"
export default {
  components: {  },
  inject: [ 'getForms', 'getPublicObj' ],
  data() {
    return {
      creative: {}
    }
  },
  computed: {
    publicObj() {
      return this.getPublicObj()
    },
    row() {
      return (this.creative.asinsItem && this.creative.asinsItem.length!= 0 && this.creative.asinsItem[0]) || {}
    }
  },
  methods: {
    // 添加商品
    addCommodity() {
      this.$gjCreate(PopupCommodity, {
        props: {
          marketId: this.publicObj.SB.marketId
        },
        on: {
          update: (row) => {
            this.creative.asins = [row[0].asin]
            this.creative.asinsItem = row
          }
        }
      });
    }
  },
  created() {
    let {  creative } = this.getForms()
    this.creative = creative
  }
};
</script>

<style scoped lang="scss">
.landing-page-title {
  color: #969696;
}
.selected-cell {
  width: 950px;
  height: 74px;
  border: 1px solid #E4E5E6;
  border-radius: 2px;
  &.not-selected {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    .add {
      padding-left: 8px;
      font-size: 12px;
      color: #666;
    }
  }
  &.selected {
    display: flex;
    align-items: center;
    font-size: 12px;
    .img {
      padding: 0 12px;
    }
    .main {
      flex: 1;
    }
    .add {
      padding: 0 50px;
      cursor: pointer;
      color: #5d9bfc;
    }
  }
}
</style>